export interface PlatformManagementApplication {
    id: string;
    name: string;
    isLive: boolean;
}

export interface PlatformManagementOrganization {
    matchingApps: PlatformManagementApplication[];
}

export const getSelectableApplications = <TOrganization extends PlatformManagementOrganization>(
    organization: TOrganization
): PlatformManagementApplication[] => {
    return organization.matchingApps;
};

export const getVisibleManagementOrganizations = <TOrganization extends PlatformManagementOrganization>(
    organizations: TOrganization[],
    normalizedQuery: string,
    selectedApplicationIds: Set<string>
) => organizations.map(organization => {
    const applications = organization.matchingApps.filter(application => normalizedQuery
        ? application.name.toLowerCase().includes(normalizedQuery)
        : application.isLive || selectedApplicationIds.has(application.id)
    ).sort((first, second) => {
        if (first.isLive !== second.isLive) return first.isLive ? -1 : 1;
        return first.name.localeCompare(second.name);
    });

    return { organization, applications };
}).filter(group => group.applications.length > 0);
